module.exports = "https://coursera_assets.s3.amazonaws.com/images/673d59c1df48fea94c84f7029764ecd3.svg";